import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { hex2rgba } from "../../utils/styles";

export const StyledTableContainer = styled.div``;

export const StyledTableWrapper = styled.div`
    display: block;
`;

export const StyledTr = styled.div`
    cursor: pointer;
`;

export const StyledTrExpanded = styled.div`
    border-radius: 10px;
    box-shadow: 0px 0px 2px 0px ${({ theme }) => hex2rgba(theme.colors.black, 0.16)};
    margin-bottom: 10px;
    transition: box-shadow 0.2s;
    &:hover {
        box-shadow: 0px 0px 4px 0px ${({ theme }) => hex2rgba(theme.colors.black, 0.25)};
    }
`;

export const StyledTrLink = styled(Link)`
    display: block;
    text-decoration: none;
    color: inherit;
    border-radius: 10px;
    box-shadow: 0px 0px 2px 0px ${({ theme }) => hex2rgba(theme.colors.black, 0.16)};
    margin-bottom: 10px;
    transition: box-shadow 0.2s;
    &:hover {
        box-shadow: 0px 0px 4px 0px ${({ theme }) => hex2rgba(theme.colors.black, 0.25)};
    }
`;

export const StyledTh = styled.div`
    padding: 20px 5px;
    &:first-child {
        padding-left: 30px;
    }
    &:last-child {
        padding-right: 30px;
    }
`;

export const StyledTd = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px 5px;
    &:first-child {
        padding-left: 30px;
    }
    &:last-child {
        padding-right: 30px;
    }
`;

export const StyledThead = styled.div`
    ${({ theme }) => theme.fonts.mulishRegular};
    font-size: 11px;
    line-height: 1.2em;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.darkGrey};
    overflow-y: auto;
    padding: 0 2px;
`;

export const StyledTbody = styled.div`
    ${({ theme }) => theme.fonts.mulishLight};
    font-size: 14px;
    line-height: 1.2em;
    letter-spacing: -0.025em;
    color: ${({ theme }) => theme.colors.darkGrey};
    overflow-y: auto;
    padding: 20px 2px;
`;

export const StyledTable = styled.div`
    border-spacing: 0;
    overflow-y: hidden;
    overflow-x: auto;
    ${({ scrollBarSize }) => scrollBarSize && css`
        ${StyledThead} {
            width: ${`calc(100% - ${scrollBarSize}px)`}
        };
        ${StyledTbody} {
            overflow-y: scroll;
        };
    `};
    ${({ offsetLeft }) => offsetLeft > 0 && css`
        ${StyledThead} {
            ${StyledTr} {
                margin-left: ${`${offsetLeft}px`};
                width: ${`calc(100% - ${offsetLeft}px)`};
                ${StyledTh} {
                   :first-child {
                        padding-left: 0;
                   }
                };
            };
        };
        ${StyledTbody} {
            ${StyledTrExpanded} {
                margin-left: ${`${offsetLeft}px`};
                width: ${`calc(100% - ${offsetLeft}px)`};
                ${StyledTd} {
                    :first-child {
                        padding-left: 0;
                    }
                };
            };
        };
    `};
`;

export const StyledFooter = styled.div`
    overflow: hidden;
    padding-bottom: 20px;
`;